'use client';

import { createContext, useContext, FC, PropsWithChildren } from 'react';
import { PhaserProps } from './types';
const PhaserContext = createContext<PhaserProps | undefined>(undefined);
export const PhaserProvider: FC<PropsWithChildren<{
  phaser?: PhaserProps;
}>> = ({
  children,
  phaser
}) => {
  return <PhaserContext.Provider value={phaser} data-sentry-element="PhaserContext.Provider" data-sentry-component="PhaserProvider" data-sentry-source-file="phaser-context.tsx">{children}</PhaserContext.Provider>;
};
export const usePhaser = () => {
  return useContext(PhaserContext);
};